module.exports = __webpack_public_path__ + "static/media/total-todo.4f782edf.svg";